import type { ComponentPropsWithRef } from 'react'
import { LuxPlusPartnerPromoClassifier, type LuxPlusPartnerPromoClassifierType } from 'luxPlus/constants/partnerPromo'

import LineUnlockAltIcon from 'LuxKit/Icons/line/LineUnlockAltIcon'
import type SvgIcon from 'LuxKit/SvgIcon'
import LineCompassIcon from 'LuxKit/Icons/line/LineCompassIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import LineShieldCheckIcon from 'LuxKit/Icons/line/LineShieldCheckIcon'
import LineShipIcon from 'LuxKit/Icons/line/LineShipIcon'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import LineRestaurantIcon from 'LuxKit/Icons/line/LineRestaurantIcon'
import LineCarIcon from 'LuxKit/Icons/line/LineCarIcon'
import LineFullAppleIcon from 'LuxKit/Icons/line/LineFullAppleIcon'
import LineWineBottleIcon from 'LuxKit/Icons/line/LineWineBottleIcon'
import LineHeadphonesIcon from 'LuxKit/Icons/line/LineHeadphonesIcon'
import LineKeySkeletonIcon from 'LuxKit/Icons/line/LineKeySkeletonIcon'
import LineTagAltIcon from 'LuxKit/Icons/line/LineTagAltIcon'
import LineBellRingIcon from 'LuxKit/Icons/line/LineBellRingIcon'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'

export const BENEFIT_VIEW_ICONS: Record<App.LuxPlusBenefitViewType, typeof SvgIcon> = {
  discounted_flash: LineBedIcon,
  discounted_flights: LinePlaneDepartureIcon,
  hotel_inclusions: LineStarIcon,
  exclusive_offers: LineKeySkeletonIcon,
  priority_support: LineHeadphonesIcon,
  discounted_tours: LineCompassIcon,
  early_access: LineUnlockAltIcon,
  discounted_insurance: LineShieldCheckIcon,
  cruise_inclusions: LineShipIcon,
  discounted_cruise: LineShipIcon,
  discounted_experiences: LineRestaurantIcon,
  partner_promo_code: LineCarIcon,
  promo: LineBellRingIcon,
  voucher: LineTagAltIcon,
  discounted_offers: LineTagAltIcon,
  partner_promos: LineTagAltIcon,
  cruise_benefits: LineShipIcon,
}

export const PARTNER_PROMO_CODE_ICONS: Record<LuxPlusPartnerPromoClassifierType, typeof SvgIcon> = {
  [LuxPlusPartnerPromoClassifier.HELLOFRESH]: LineFullAppleIcon,
  [LuxPlusPartnerPromoClassifier.TURO]: LineCarIcon,
  [LuxPlusPartnerPromoClassifier.WINE_SELECTORS]: LineWineBottleIcon,
}

interface Props extends ComponentPropsWithRef<typeof SvgIcon> {
  benefit: App.LuxPlusBenefitView
}

export default function LuxPlusBenefitIcon({ benefit, ...rest }: Props) {
  const Icon = BENEFIT_VIEW_ICONS[benefit.type]
  if ('classifier' in benefit && benefit.classifier) {
    const PartnerPromoIcon = PARTNER_PROMO_CODE_ICONS[benefit.classifier]
    if (PartnerPromoIcon) {
      return <PartnerPromoIcon {...rest} />
    }
  }
  return <Icon {...rest} />
}
